import { Redirect } from "react-router-dom";
import { todayString } from "../helpers/dateHelpers";

export const RedirectToToday = () => <Redirect to={"/day/" + todayString()} />;
export const RedirectToCurrentMonth = () => <Redirect to={"/month/" + todayString()} />;
